export function formatCurrency(amount) {
  if (amount === null || amount === undefined || amount === "") return "";

  let numValue = typeof amount === "string" ? parseFloat(amount) : amount;

  if (isNaN(numValue)) return "";

  const hasDecimal = numValue % 1 !== 0;

  // Indian numbering system formatting
  const formatter = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  });

  return `Rs ${formatter.format(numValue)}`;
}
